import login from "./login";

export default {
  translation: {
    login
  }
}